module.exports = __webpack_public_path__ + "img/20190803110347QQ截图20190803011537.6f9a0ace.png";